// extracted by mini-css-extract-plugin
export default {"interactive-content":"interactive-content_A9HdGUi3","dragging":"dragging_aQ7Qm3hm"};